<template>
  <div>
    <div class="header pt-12 pb-5" v-if="title != null"
         v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
         v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
      <h1>{{ title }}</h1>
    </div>

    <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 fluid
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
      <v-row>
        <v-col :cols="img ? 8 : 12">
          <p class="mb-6">{{ description }}</p>
          <v-btn class="editable-list-plus-button" @click="() => startCreateEntry()" dark tile v-if="createItem">
            <slot name="icon">
              <v-icon class="pr-1">icon-plus</v-icon>
            </slot>
            {{ createBtnText }}
          </v-btn>
        </v-col>
        <v-col v-if="img != null" align="right" cols="4">
          <v-img :max-width="imgMaxWidth" :src="img" :style="'z-index: 30;' + imgStyle" class="img" contain/>
        </v-col>
      </v-row>
    </v-container>

    <!--No Screener available (DEFAULT)-->
    <div v-if="!value || !value.length" style="background-color: #ffffff">
      <p v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
         v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
         class=" py-8"
         style="color: #99a0a4">{{ noData }}</p>
    </div>

    <div v-if="value && value.length > 0" style="background-color: #fff; z-index: 21;">
      <h2 v-if="listTitle"
          v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
          style="padding-top: 8px; padding-bottom: 12px;"
          v-html="listTitle"/>

      <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   fluid
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
        <v-row v-for="(item, index) in value"
               :key="item.id || index">
          <v-col cols="10" sm="6">
            <slot :item="item" name="item-title">
              <fin-editable-property :editFunction="(val) => updateItemName(item, val)"
                                     :orginal-value="item.name"
                                     :value="item.name"
                                     class="name"
                                     ref="rename"
                                     :title="dialogTitle"
                                     :submit-button="dialogBtn"
                                     :clickable="titleClickable"
                                     @propertyClicked="titleClicked(item.id || index)">
                <template #default="{model,change}" class="name">
                  <slot name="item-title" :item="item"/>
                  <v-text-field
                    :rules="[ v => !!v || 'Name wird benötigt']"
                    :value="model"
                    :label="dialogTextfieldLabel"
                    @input="change"
                  />
                </template>
              </fin-editable-property>
            </slot>
            <p class="subline">
              <slot name="item-subline" :item="item"/>
            </p>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.xs" align="right" cols="2">
            <v-menu :nudge-bottom=10
                    :nudge-left=50
                    :offset-y="true"
                    bottom>
              <template #activator="{ on }">
                <v-btn v-on="on"
                       class="px-0"
                       small
                       text>
                  <v-icon>icon-contextmenu-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <slot :item="item" :showRename="()=> $refs.rename[index].show()" name="context-menu"/>
              </v-list>
            </v-menu>
          </v-col>

          <v-col :style="{ textAlign: $vuetify.breakpoint.xs ? 'center' : 'right' }" cols="12" sm="6">
            <slot :item="item"
                  name="context-actions-subline"/>
            <slot name="context-actions"
                  :item="item"/>
            <v-menu :nudge-bottom=10
                    :nudge-left=50
                    :offset-y="true"
                    v-if="!$vuetify.breakpoint.xs"
                    bottom>
              <template #activator="{ on }">
                <v-btn text
                       v-on="on"
                       class="px-0"
                       x-small>
                  <v-icon>icon-contextmenu-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <slot name="context-menu" :item="item" :showRename="()=> $refs.rename[index].show()"/>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import {EventBus} from '@/plugins/fincraft'
import FinEditableProperty from '@/components/pages/profile/EditableProperty'
import PriceModel from "@/mixins/PriceModel"

export default {
  name: 'FinEditableList',
  components: {FinEditableProperty},
  mixins: [PriceModel],
  props: {
    value: {
      type: Array
    },
    dialogTitle: {
      type: String
    },
    dialogBtn: {
      type: String
    },
    dialogTextfieldLabel: {
      type: String
    },
    noData: {
      type: String,
      default: 'Noch keinen Einträge angelegt.'
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    img: {
      type: String,
      default: null
    },
    imgDescription: {
      type: String,
      default: null
    },
    imgMaxWidth: {
      type: [String, Number],
      default: '100%'
    },
    imgStyle: {
      type: String
    },
    createBtnText: {
      type: String,
      default: 'Neuer Eintrag'
    },
    /** Function to check if the creation of a new item is allowed */
    checkIfPromptAllowed: {
      type: Function,
      default: () => {
        return true
      }
    },
    /** Function to be called if the creation of a new item is not allowed */
    notAllowedAction: {
      type: Function,
      default: () => {
        return true
      }
    },
    prompt: {
      type: Object,
      default: () => {
        return {
          title: 'Wie soll dein Eintrag heißen?',
          dialogWidth: 448,
          confirmBtn: 'Speichern',
          input: true,
          inputText: '',
          inputLabel: 'Name',
          textBelow: ''
        }
      }
    },
    updateItemName: {
      type: Function
    },
    createItem: {
      type: Function
    },
    titleClickable: {
      type: Boolean,
      default: false
    },
    listTitle: {
      type: String
    },
  },
  methods: {
    async startCreateEntry() {
      const checkIfPromptAllowed = this.checkIfPromptAllowed()
      if (checkIfPromptAllowed) {
        const params = await this.$confirm(this.prompt)
        const name = params.inputText

        try {
          const newItem = await (this.createItem(name))
          if (newItem) {
            const copy = [newItem, ...this.value]
            this.$emit('input', copy)

            this.$toasted.global.finToast({
              message: `Dein neuer Eintrag %entryName% wurde erstellt`,
              placeholders: [{name: "entryName", content: name}],
              type: 'success',
              options: {
                action: {
                  text: 'Anpassen',
                  onClick: () => {
                    EventBus.$emit('edit', newItem)
                  }
                }
              }
            })
          }
        } catch (error) {
          console.error("EditableList create error", error)
          this.$toasted.global.finToast({
            message: 'Beim Anlegen von %entryName% ist ein Fehler aufgetreten.',
            placeholders: [{name: "entryName", content: name}],
            type: 'error'
          })
        }
      } else {
        this.notAllowedAction()
      }
    },
    titleClicked(val) {
      if (this.titleClickable) {
        this.$emit('titleClicked', val)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.heading {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0;
}

.name {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  margin-bottom: 6px;
}

.subline {
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
  margin-bottom: 0;
  text-transform: uppercase;
  color: $fin-color-cool-grey;
}

.creator {
  font-size: 12px;
  font-weight: 600;
  color: $fin-color-cool-grey;
}

.btnEdit {
  border: 2px solid $fin-color-primary-dark !important;
  font-weight: bold;
  font-size: 12px;
}

::v-deep .v-list-item button {
  width: 100%;

  .v-btn__content {
    justify-content: left;
  }
}
</style>
